import { authApi } from '@api/index';
import { IResetPasswordRequestFormData } from '@components/ResetPassword/ResetPasswordRequestForm';
import { useMutation } from 'react-query';

export const useRequestResetPasswordMutation = () => {
  return useMutation({
    mutationFn: (data: IResetPasswordRequestFormData) => authApi.requestResetPassword(data),
  });
};
